import moment from 'moment';
import dayjs from 'dayjs';

export const formattedDate = (date) => {
  return dayjs(date).format('YYYY-MM-DD');
};
export const formattedTime = (date) => {
  return moment(date).format('HH:mm:ss');
};

export const dateFormatChange = (date) => {
  return date.split('-').reverse().join('-');
};

export const customformattedDate = (date) => {
  const checkDate = moment(date, 'DD-MM-YYYY', true).isValid();
  if (!checkDate) {
    return date;
  } else {
    const convertedDate = formattedDate(date);
    if (date === moment(convertedDate).format('YYYY-DD-MM') || !moment(convertedDate, 'DD-MM-YYYY', true).isValid()) return convertedDate;
    else return date;
  }
};

export const dateWithSlash = (date) => {
  const checkDate = moment(date, 'MM/DD/YYYY', true).isValid();
  if (!checkDate) {
    return date;
  } else {
    const result = moment(date).format('YYYY-MM-DD');
    const convertedDate = moment(result).format('MM/DD/YYYY');
    return convertedDate;
  }
};

export const yearlyFormat = (date) => {
  return moment(date).format('YYYY-MM-DD');
};

export const getPreviousDate = (date, days) => {
  var newDate = new Date(date);
  let today = new Date();
  today = moment(today);
  const previousDate = new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate() - Number(days));

  return moment(previousDate).format('YYYY-MM-DD');
};

export const getDateDifferenceInDays = (dateOne, dateTwo) => {
  dateOne = moment(dateOne);
  const differenceInDays = dateOne.diff(dateTwo, 'day');
  return differenceInDays;
};

export const pervMonth = () => {
  var today = new Date();
  const prevweek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 30);
  return moment(prevweek).format('YYYY-MM-DD');
};

export const monthsDifference = (date) => {
  date = moment(date).format('YYYY-MM');
  return date;
};

export const daysDifference = (date) => {
  date = moment(date).format('YYYY-MM-DD');
  return date;
};

export const convertMinsToHrsMins = (mins) => {
  let h = Math.floor(mins / 60);
  let m = mins % 60;
  h = h < 10 ? '0' + h : h; // (or alternatively) h = String(h).padStart(2, '0')
  m = m < 10 ? '0' + m : m; // (or alternatively) m = String(m).padStart(2, '0')
  return `${h}:${m}`;
};

export const monthDiff = (dateFrom, dateTo) => {
  const months = dateTo.getMonth() - dateFrom.getMonth() + 12 * (dateTo.getFullYear() - dateFrom.getFullYear());
  return months > 1 ? months + ' months ago' : months + ' month ago';
};